// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension="
// @generated from file common/v1/types.proto (package common.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2'
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2'
import type { Message } from '@bufbuild/protobuf'

/**
 * Describes the file common/v1/types.proto.
 */
export const file_common_v1_types: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChVjb21tb24vdjEvdHlwZXMucHJvdG8SCWNvbW1vbi52MSJLCgdDcmVhdG9yEg8KB3VzZXJfaWQYASABKAkSDgoGb3JnX2lkGAIgASgJEhAKCHRpbWV6b25lGAMgASgJEg0KBWVtYWlsGAQgASgJYgZwcm90bzM'
  )

/**
 * @generated from message common.v1.Creator
 */
export type Creator = Message<'common.v1.Creator'> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string

  /**
   * @generated from field: string org_id = 2;
   */
  orgId: string

  /**
   * @generated from field: string timezone = 3;
   */
  timezone: string

  /**
   * @generated from field: string email = 4;
   */
  email: string
}

/**
 * Describes the message common.v1.Creator.
 * Use `create(CreatorSchema)` to create a new message.
 */
export const CreatorSchema: GenMessage<Creator> = /*@__PURE__*/ messageDesc(file_common_v1_types, 0)
